import { useRootLoaderData } from 'components/Root.loader'
import Tab from 'components/ui/Tabs/Tab'
import Tabs from 'components/ui/Tabs/Tabs'
import { AUTHORITIES } from 'config'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export default function Settings() {
  const rootData = useRootLoaderData()
  const pages = rootData && selectPages(rootData.userGroupConfig, rootData.profile.authority)

  const location = useLocation()
  const navigate = useNavigate()
  // location.pathname ex: /normal/settings/display/~~
  const tabsValue = location.pathname.split('/')[3]

  const tabLinks = pages.map(({ label, path }) => {
    return <Tab key={label} label={label} value={path} />
  })

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    navigate(`./${newValue}`)
  }

  return (
    <>
      <h1>設定</h1>
      <Tabs
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        value={tabsValue}
        variant="scrollable"
        data-testid="settings-tab"
      >
        {tabLinks}
      </Tabs>
      <Outlet />
    </>
  )
}

const selectPages = ({ useOCRBuilder, useConcur }, authority) =>
  [
    {
      label: '表示設定',
      path: 'display',
      display: true,
    },
    {
      label: 'Concur接続',
      path: 'concur',
      display: useConcur,
    },
    {
      label: 'Template OCR接続',
      path: 'ocr-builder',
      display: useOCRBuilder && authority === AUTHORITIES.ADMIN,
    },
    {
      label: 'ユーザー設定',
      path: 'users',
      display: authority === AUTHORITIES.ADMIN,
    },
    {
      label: 'グループ設定',
      path: 'group',
      display: authority === AUTHORITIES.ADMIN,
    },
    {
      label: '運用ルール設定',
      path: 'rules',
      display: true,
    },
  ].filter((x) => x.display)
